import styled from 'styled-components';

export const Image = styled.img`
  max-width: 480px;
`;

export const VideoWrapper = styled.div`
  position: relative;
  display: block;
  max-width: 100%;
  max-height: 490px;
  padding-top: 1px; /* avoids video getting cut out at the top*/
  margin: 20px auto 0;
  top: 50%;
  transform: translateY(-50%);

  &:after {
    content: '';
    top: 0;
    left: 50%;
    width: 657px;
    height: 490px;
    position: absolute;
    border: 2px solid #f8f8f8;
    background-color: transparent;
    pointer-events: none;
    transform: translate(-50%, 0);
  }

  video,
  img {
    height: 100%;
    max-width: 100%;
  }
  img {
    margin: 1px 0 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/Step5/styled.js